import React from 'react';
import { getText } from '@storebrand-digital/fms-translations';
import { Chip } from '@storebrand-digital/pretzel';

export interface FilterChipProps {
  id: string;
  label: string;
  value: string;
  trackId: string;
  onRemove: () => void;
  name?: string;
  key?: string;
}

const baseChipProps = {
  variant: 'input' as const,
  density: 'compact' as const,
  checked: true,
};

function FilterChip({
  id,
  label,
  value,
  trackId,
  onRemove,
  name,
}: FilterChipProps) {
  return (
    <Chip
      id={id}
      name={name}
      {...baseChipProps}
      label={label || '(blank)'}
      value={value}
      onValueChange={onRemove}
      aria-label={`${getText('removeFilter')}: ${label}`}
      labelProps={{
        'data-trackid': trackId,
      }}
    />
  );
}

export default FilterChip;
